export const capitalize = (s) => (s[0].toUpperCase() + s.slice(1));
